/*
  Kalessie - BNPL strip (PDP and cart).

  Two jobs:
  1. Keep the "1 of 4 payments" figure correct when the variant changes.
  2. Make the tabby / tamara marks open each provider's OWN explainer as a
     popup, without ever navigating away.

  tabby: their documented on-site-messaging popup URL, framed in our own
  lightbox. That endpoint sends no X-Frame-Options and no frame-ancestors, so
  it is safe to embed, and it needs no SDK at all.

  tamara: no equivalent URL exists, so the official widget is mounted in a
  visually-hidden host and we trigger its internal modal, restyled to the same
  dialog box as tabby's rather than taking over the screen.

  Everything resolves the strip at click time and the overlay is owned by this
  script rather than the markup, because on the cart page the whole summary is
  re-rendered when a cross-sell is added — anything cached at load, or any
  handler bound to the original element, would be silently dropped.

  If either provider is unreachable the mark falls back to their terms page,
  so the control is never a dead end.
*/
(function () {
  var FALLBACK = { tabby: 'https://tabby.ai/en-AE', tamara: 'https://tamara.co/en-AE' };

  function root() { return document.querySelector('[data-kal-bnpl]'); }

  function cfg() {
    var el = root();
    if (!el) return null;
    return {
      amount: parseFloat(el.dataset.amount || '0'),
      currency: el.dataset.currency || 'AED',
      lang: (el.dataset.lang || 'en').slice(0, 2),
      tabbyKey: el.dataset.tabbyKey,
      tabbyMerchant: el.dataset.tabbyMerchant || 'default',
      tamaraKey: el.dataset.tamaraKey,
    };
  }

  function render(cents) {
    var el = root();
    var amountEl = el && el.querySelector('[data-kal-bnpl-amount]');
    if (!amountEl || typeof cents !== 'number' || cents <= 0) return;
    var v = cents / 4 / 100;
    var num = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    // Keep the shop's own money markup and swap only the number, so the figure
    // never drifts from the price row above it.
    var sym = amountEl.querySelector('.custom-currency-symbol');
    if (sym) {
      var sep = sym.nextSibling ? (String(sym.nextSibling.textContent).match(/^\s*/) || [''])[0] : ' ';
      while (sym.nextSibling) amountEl.removeChild(sym.nextSibling);
      amountEl.appendChild(document.createTextNode(sep + num));
    } else {
      amountEl.textContent = ((window.KAL && window.KAL.moneyPrefix) || 'AED') + ' ' + num;
    }
    el.dataset.price = cents;
    el.dataset.amount = cents / 100;
  }

  // ── tabby: documented popup URL, framed in our own lightbox ────────
  function tabbyUrl(c) {
    return (
      'https://checkout.tabby.ai/promos/product-page/installments/' +
      (c.lang === 'ar' ? 'ar' : 'en') +
      '/?price=' + encodeURIComponent(c.amount.toFixed(2)) +
      '&currency=' + encodeURIComponent(c.currency) +
      '&merchant_code=' + encodeURIComponent(c.tabbyMerchant) +
      '&public_key=' + encodeURIComponent(c.tabbyKey)
    );
  }

  var overlay = null;
  var lastFocus = null;

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'kal-bnpl__modal';
    overlay.setAttribute('data-kal-bnpl-modal', '');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="kal-bnpl__backdrop" data-kal-bnpl-close></div>' +
      '<div class="kal-bnpl__dialog" role="dialog" aria-modal="true" aria-label="How tabby works">' +
      '<button type="button" class="kal-bnpl__close" data-kal-bnpl-close aria-label="Close">&times;</button>' +
      '<iframe class="kal-bnpl__frame" title="Pay in 4 with tabby" loading="lazy"></iframe>' +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-kal-bnpl-close]')) closeModal();
    });
    // Dawn's scroll-trigger animation leaves a transform on the product
    // wrappers, which would capture fixed positioning — keep it on <body>.
    document.body.appendChild(overlay);
    return overlay;
  }

  function openModal(c) {
    if (!c || !c.amount) return false;
    var o = buildOverlay();
    o.querySelector('.kal-bnpl__frame').src = tabbyUrl(c);
    lastFocus = document.activeElement;
    o.hidden = false;
    document.body.classList.add('kal-bnpl-locked');
    o.querySelector('.kal-bnpl__close').focus();
    return true;
  }

  function closeModal() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.classList.remove('kal-bnpl-locked');
    // Drop the frame so a re-open always reloads at the current amount.
    overlay.querySelector('.kal-bnpl__frame').removeAttribute('src');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && !overlay.hidden) closeModal();
  });

  // ── tamara: official widget, triggered through its own modal ───────
  var initial = cfg();
  window.tamaraWidgetConfig = {
    lang: initial ? initial.lang : 'en',
    country: 'AE',
    publicKey: initial ? initial.tamaraKey : '',
    css: ':host { --font-primary: inherit !important; --font-secondary: inherit !important; }',
    style: { fontSize: '13px', badgeRatio: 1.1 },
  };

  function syncTamara() {
    var c = cfg();
    var w = document.getElementById('kal-tamara-host');
    if (w && c && c.amount) w.setAttribute('amount', c.amount.toFixed(2));
  }

  (function loadTamara() {
    var src = 'https://cdn.tamara.co/widget-v2/tamara-widget.js';
    if (document.querySelector('script[src="' + src + '"]')) { syncTamara(); return; }
    var s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = syncTamara;
    document.head.appendChild(s);
  })();

  // Tamara's popup is client-rendered in an open shadow root — there is no URL
  // to frame — so give it the same dialog box as the tabby one rather than
  // letting it take over the whole screen.
  var TAMARA_DIALOG_CSS = [
    '.tamara-popup{align-items:center !important;justify-content:center !important;}',
    '.tamara-popup__wrap{',
    'width:min(440px, calc(100vw - 32px)) !important;',
    'max-width:min(440px, calc(100vw - 32px)) !important;',
    'height:min(620px, calc(100vh - 64px)) !important;',
    'max-height:min(620px, calc(100vh - 64px)) !important;',
    'margin:auto !important;border-radius:0 !important;background:#fff !important;',
    'box-shadow:0 18px 50px rgba(0,0,0,.22) !important;}',
    '.tamara-popup__close{position:absolute !important;top:8px !important;right:8px !important;',
    'left:auto !important;bottom:auto !important;border-radius:0 !important;}',
  ].join('');

  function styleTamaraPopup() {
    var pop = document.querySelector('tamara-widget-popup');
    if (!pop || !pop.shadowRoot) return false;
    if (pop.shadowRoot.getElementById('kal-tamara-dialog')) return true;
    var s = document.createElement('style');
    s.id = 'kal-tamara-dialog';
    s.textContent = TAMARA_DIALOG_CSS;
    pop.shadowRoot.appendChild(s);
    return true;
  }

  // The widget listens for a full pointer sequence; a bare .click() is ignored.
  function fire(el) {
    if (!el) return false;
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      el.dispatchEvent(new MouseEvent(type, { bubbles: true, composed: true, cancelable: true, view: window }));
    });
    return true;
  }

  function openTamara() {
    var w = document.getElementById('kal-tamara-host');
    if (!w || !w.shadowRoot) return false;
    var sr = w.shadowRoot;
    var trigger =
      sr.querySelector('.tamara-inline-learn-more-link') ||
      sr.querySelector('[class*="learn-more"], [class*="learn_more"]') ||
      sr.querySelectorAll('a, button, [role="button"]')[0];
    if (!fire(trigger)) return false;
    // The popup element is built on first open, so poll briefly for it.
    var tries = 0;
    (function wait() {
      if (styleTamaraPopup() || ++tries > 40) return;
      setTimeout(wait, 50);
    })();
    return true;
  }

  // Delegated so it keeps working after the cart summary is re-rendered.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kal-bnpl-open]') : null;
    if (!btn) return;
    e.preventDefault();
    var which = btn.getAttribute('data-kal-bnpl-open');
    var opened = false;
    try { opened = which === 'tabby' ? openModal(cfg()) : openTamara(); } catch (err) { opened = false; }
    if (!opened) window.open(FALLBACK[which], '_blank', 'noopener');
  });

  // ── Variant changes (PDP) ─────────────────────────────────────────
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      if (!v || typeof v.price !== 'number') return;
      render(v.price);
      syncTamara();
      if (overlay && !overlay.hidden) overlay.querySelector('.kal-bnpl__frame').src = tabbyUrl(cfg());
    });
  }

  // ── Cart re-render: the strip is replaced, so re-point tamara at the
  //    new amount the server just printed. ───────────────────────────
  document.addEventListener('cart:updated', syncTamara);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncTamara);
  }
})();
